import { PushCardToIntegrationToolResult } from '@/api/storymapCardDetails/commands';
import { isSubtask, isTask } from '@/pages/main/storymap/store/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState, Subtask, Task, Activity } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer } = useStorymapStore();

export class CardPushedToIntegrationTool extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'CardPushedToIntegrationTool';

    public constructor(public card: Activity | Task | Subtask, public res: PushCardToIntegrationToolResult) {
        super(CardPushedToIntegrationTool.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: CardPushedToIntegrationTool): void => {
    const taskId = isSubtask(action.card) ? action.card.taskId : action.card.id;
    const activityId = isSubtask(action.card) ? action.card.activityId : isTask(action.card) ? action.card.activityId : action.card.id;

    if (action.res.Activity) {
        const activity = state.activities.find((x) => x.id === activityId);

        activity.linkedUrl = action.res.Activity.LinkedItemUrl;
        activity.linkedItemKey = action.res.Activity.LinkedItemKey;
        activity.linkedItemTypeId = action.res.Activity.LinkedItemTypeId;
        activity.linkedItemTypeName = action.res.Activity.LinkedItemTypeName;
        activity.isLinkedToIntegrationTool = true;
    }

    if (action.res.Task) {
        const task = state.tasks.find((x) => x.id === taskId);

        task.linkedUrl = action.res.Task.LinkedItemUrl;
        task.linkedItemKey = action.res.Task.LinkedItemKey;
        task.linkedItemTypeId = action.res.Task.LinkedItemTypeId;
        task.linkedItemTypeName = action.res.Task.LinkedItemTypeName;
        task.isLinkedToIntegrationTool = true;
    }

    if (action.res.Subtask) {
        const subtask = state.subtasks.find((x) => x.id === action.card.id);

        subtask.linkedUrl = action.res.Subtask.LinkedItemUrl;
        subtask.linkedItemKey = action.res.Subtask.LinkedItemKey;
        subtask.linkedItemTypeId = action.res.Subtask.LinkedItemTypeId;
        subtask.linkedItemTypeName = action.res.Subtask.LinkedItemTypeName;
        subtask.status = action.res.Subtask.Status;
        subtask.isLinkedToIntegrationTool = true;
    }
};

//@ts-ignore
registerReducer(CardPushedToIntegrationTool.ACTION_TYPE, reducer);
